import styled from "styled-components";
const Media = {
  Nav: "@media(max-width:1000px)",
  PhoneLarge: "@media(max-width:600px)",
  Laptop: "@media(max-width:1150px)",
  Tablet: "@media(max-width:1000px)",
};
export const Section = styled.div`
  position: fixed;
  bottom: 0;
  right: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 99;
  ${Media.Tablet} {
    display: none;
  }
  .column {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    ${Media.Tablet} {
      flex-direction: row;
    }
  }

  .sociaLinks {
    gap: 0.5rem;
    .icon {
      width: 2rem;
      height: 2rem;
      color: var(--blue);
    }

    hr {
      width: 3px;
      height: 5rem;
      background-color: var(--blue);
      ${Media.Tablet} {
        display: none;
      }
    }
  }
`;
